export const month_options = [
    {name: 'Январь', value: 1},
    {name: 'Февраль', value: 2},
    {name: 'Март', value: 3},
    {name: 'Апрель', value: 4},
    {name: 'Май', value: 5},
    {name: 'Июнь', value: 6},
    {name: 'Июль', value: 7},
    {name: 'Август', value: 8},
    {name: 'Сентябрь', value: 9},
    {name: 'Октябрь', value: 10},
    {name: 'Ноябрь', value: 11},
    {name: 'Декабрь', value: 12},
]

function isSaveChange(status) {
    // if (status in ['Создан', 'Редактирован']){
    if (status === 'Создан' || status === 'Редактирован') {
        return false;
    } else {
        return true;
    }

}

function getAllRoleLevel(ouser) {
    const arr_role_level = []
    for (let i = 0; i < ouser.role.length; ++i) {
        arr_role_level.push(ouser.role[i].access_level)
    }
    return arr_role_level
}

function isRecipient(ouser) {
    for (let i = 0; i < ouser.role.length; ++i) {
        if (ouser.role[i].access_level === 3) {
            return true;
        }
        return false;
    }
}

function isApproved(ouser) {
    for (let i = 0; i < ouser.role.length; ++i) {
        if (ouser.role[i].access_level === 2) {
            return true;
        }
        return false;
    }
}

function isImpl(ouser) {
    for (let i = 0; i < ouser.role.length; ++i) {
        if (ouser.role[i].access_level === 1) {
            return true;
        }
        return false;
    }
}

export {isSaveChange, getAllRoleLevel, isApproved, isImpl, isRecipient}
